import styles from "./IonOrb.module.css";

/**
 * ION's orb: the master image, whole, so the sphere keeps its rim and shading.
 * Unless `still`, a second copy drifts slowly over it, faded out towards the edge,
 * so the colours flow while the sphere stays put. Only the orb a visitor should
 * be looking at moves; those beside past messages are `still`. It holds still for
 * reduced motion too.
 *
 * `size` is set on the element itself, not in a stylesheet: two stylesheets setting
 * it would win or lose by load order, which changes with the page a visitor enters
 * on, and the orb could fill the whole panel.
 */
export function IonOrb({ size, className = "", still = false }: { size: number; className?: string; still?: boolean }) {
  return (
    <span className={`${styles.orb} ${className}`} style={{ width: size, height: size }} aria-hidden="true">
      <img className={styles.base} src="/chat-orb.png" alt="" width={size} height={size} />
      {!still && (
        <span className={styles.flow}>
          <img src="/chat-orb.png" alt="" width={46} height={46} />
        </span>
      )}
    </span>
  );
}
